
<template>
  <el-menu
    class="top-el-menu navigation"
    :default-active="state.toIndex"
    background-color="transparent"
    text-color="#AEB9C2"
    active-text-color="#fff"
    :collapse-transition="false"
    :ellipsis="false"
    @select="jump"
  >
    <template v-for="item in state.menu">
      <el-menu-item
        :index="item.path"
        :key="item.name"
        :class="{ active: state.toIndex === item.path }"
        v-if="item && item.meta && !item.meta.hidden && (!item.meta.children || !item.meta.isRoot)"
      >
        <template #title>
          <el-badge :value="item.count" :hidden="!item.count" :max="99">
            {{ item.meta?.title }}
          </el-badge>
        </template>
      </el-menu-item>
      <el-sub-menu
        :index="item.path"
        :key="item.name"
        v-if="item && item.meta && !item.meta.hidden && item.meta.children && item.meta.isRoot"
      >
        <template #title>{{ item.meta.title }}</template>
        <template v-for="i in item.children">
          <el-menu-item v-if="!i.meta?.hidden" :index="i.path" :key="i.name"
            :class="[state.toIndex === i.path ? 'active' : '', 'children']"
            >
            {{ i.meta?.title }}
          </el-menu-item>
        </template>
      </el-sub-menu>
    </template>
  </el-menu>
</template>

<script setup>
import { computed, reactive, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { routes } from "@/router"
import { flattenTreeData } from "@/service"
// import { getTaskAllCount } from "@/api/approveCenter"
// import eventBus from "@/service/eventBus"
import Navigation from "./Navigation.vue"

const state = reactive({
  menu: [],
  toIndex: "/home",
  approveCount: 0,
})
const $route = useRoute(),
  $router = useRouter()
const store = useStore()
let menuPathArr = []

onMounted(() => {
  // state.menu = computed(() => {
  //   const menus = store.state.menu
  //   // const userInfo = store.state.user
  //   console.log(menus, 'menus')
  //   const res = mapRouterMenu(routes, menus)
  //   console.log(res, 'res', routes)
  //   return res
  // })
  
  getMenus()
  state.toIndex = computed(() => {
    let path = $route.matched[1].path
    if (path == '/dashboard') {
      path = '/'
    }
    return path
  })

})

const getMenus = () => {
  store.dispatch('GetUserAuthor').then(res => {
    const menus = flattenTreeData(res)
    const copyRoutes = deepCopy(routes)
    console.log(menus, copyRoutes, 'sss')
    mapRouterMenu(copyRoutes, menus)
  })
}

const deepCopy = (obj) => {
  // 只拷贝对象
  if (typeof obj !== 'object') return;
  // 根据obj的类型判断是新建一个数组还是一个对象
  var newObj = obj instanceof Array ? [] : {};
  for (var key in obj) {
    // 遍历obj,并且判断是obj的属性才拷贝
    if (obj.hasOwnProperty(key)) {
      // 判断属性值的类型，如果是对象递归调用深拷贝
      newObj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key];
    }
  }
  return newObj
}

const mapRouterMenu = (route, menus) => {
  let arr = []
  for (let current in route) {
    let rItem = route[current]
    if (!rItem.code) {
      arr.push(rItem)
    } else {
      if (rItem.children && rItem.children.length > 0) {
        rItem.children = rItem.children.filter(item => {
          return menus.find(v => v.path == item.path)
        })
        if (rItem.children.length > 0) {
          arr.push(rItem)
        }
      } 
    }
  }
  console.log(arr, 'arr')
  state.menu = arr 
}

const jump = index => {
  let path = index
  // 点击"控制台"菜单时，固定跳到 /dashboard（避免命中根路由 redirect() 跳转到 firstMenuPath=/user/list）
  if (path === '/' || (path && path.replace(/\/+$/, '') === '')) {
    path = '/dashboard'
  }
  let value = flattenTreeData(store.state.menu)
  const current = value.find(i => i.path === path)
  const allRoutes = flattenTreeData(routes)
  const routeItem = allRoutes.find(r => r.path === path)
  const tabName = (routeItem && routeItem.meta && routeItem.meta.title)
    || (current && current.name)
    || (routeItem && routeItem.name)
    || path
  const visitedTab = current
    ? { ...current, name: tabName, path: path }
    : { path: path, name: tabName }
  store.commit("SET_VISITEDMENU", visitedTab)
  $router.push({ path })
}
</script>
<style lang="less" scoped>
.el-menu-item span {
  margin-left: 16px;
}
.top-el-menu {
  border-bottom: none !important;
  // margin-left: 80px;
  :deep(.el-sub-menu__title) {
    // color: #fff !important;
    border-bottom: none !important;
    .iconfont {
      margin-right: 3px;
    }
  }
  .el-sub-menu.is-active {
    :deep(.el-sub-menu__title) {
      font-size: 14px;
    }
  }
  .el-sub-menu.active {
    :deep(.el-sub-menu__title) {
      font-size: 16px;
    }
  }
  .el-sub-menu.is-active {
    border-bottom: 0 none;
  }

  :deep(.el-menu-item, .el-sub-menu) {
    color: #222;
    border-bottom: 0;
    @navItemRadius: 8px;
    font-size: 14px;
    font-weight: 400;
    &:hover,
    &:visited,
    &:focus {
      color: #3096fc !important;
      background: #f6f8fa !important;
    }
    // &.is-active {
    &.active {
      font-size: 14px;
      border-bottom: none;
      color: #3096fc !important;
      background: #f6f8fa;
      font-weight: 600;
      .navigation__name {
        color: @navFontActiveColor;
        font-weight: 600;
      }
      &::before,
      &::after {
        background: radial-gradient(
          @navItemRadius at @navItemRadius 0px,
          transparent @navItemRadius,
          @navBgColor @navItemRadius
        );
      }
      &:hover {
        background: #f6f8fa;
      }
      &.is-active {
        &:focus {
          color: #3096fc !important;
          background: #f6f8fa !important;
        }
      }
    }
    &.is-active {
      &:focus {
        // color: #fff !important;
        // background: #077dff !important;
      }
    }
  }

  // :deep(.el-sub-menu) {
  //   color: #222;
  //   border-bottom: 0;
  //   @navItemRadius: 8px;
  //   font-size: 18px;
  //   font-weight: 400;
  //   &:hover,
  //   &:visited,
  //   &:focus {
  //     color: #3096fc !important;
  //     background: #f6f8fa !important;
  //   }
  //   // &.is-active {
  //   &.active {
  //     font-size: 18px;
  //     border-bottom: none;
  //     color: #3096fc !important;
  //     background: #f6f8fa;
  //     font-weight: 600;
  //     .navigation__name {
  //       color: @navFontActiveColor;
  //       font-weight: 600;
  //     }
  //     &::before,
  //     &::after {
  //       background: radial-gradient(
  //         @navItemRadius at @navItemRadius 0px,
  //         transparent @navItemRadius,
  //         @navBgColor @navItemRadius
  //       );
  //     }
  //     &:hover {
  //       background: #f6f8fa;
  //     }
  //     &.is-active {
  //       &:focus {
  //         color: #3096fc !important;
  //         background: #f6f8fa !important;
  //       }
  //     }
  //   }
  //   &.is-active {
  //     &:focus {
  //       color: #fff !important;
  //       background: #077dff !important;
  //     }
  //   }
  // }
  .inside {
    padding-left: 20px !important;
    .text-overflow {
      display: block;
      width: 90%;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.children {
  color: #151a1d !important;
  font-size: 14px;
  &:hover {
    color: #3096fc !important;
    background: #e5ebf4 !important;
  }
}
</style>
